angular.module('eStories.wishList', [
    /*eStories Browse*/
    'eStories.catalog.model',
    'eStories.compnt.grid',
    'eStories.paging.model',
    'eStories.sortFilter',
    'eStories.library.model'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.wishList', {
                url: 'wishlist?pageNumber&sortField&grid',
                views: {
                    'mainView@': {
                        controller: 'WishListCtrl as wishListCtrl',
                        templateUrl: 'wishList/wishList.tmpl.html'
                    }
                }
            });
    }])

    .controller('WishListCtrl', [
        'CatalogModel',
        'PagingModel',
        'LibraryModel',
        'SortFilterFactory',
        '$stateParams',
        '$timeout',
        '$rootScope',
        '$scope',
        '$location',
        'SeoModel',
        '$state',
        'GA',
        function (CatalogModel,
                  PagingModel,
                  LibraryModel,
                  SortFilterFactory,
                  $stateParams,
                  $timeout,
                  $rootScope,
                  $scope,
                  $location,
                  SeoModel,
                  $state,
                  GA) {

            const wishListCtrl = this;
            this.tabList = [];
            this.selectedSortFieldIndex = parseInt($stateParams.sortField) || 0;
            this.showGridView = parseInt($stateParams.grid) === 1;
            this.wishlistTotalCount = 0;
            this.currentPagination = {pageNumber: parseInt($stateParams.pageNumber) || 1};
            this.sortFieldList = [
                {id: 'DATE_ADDED', name: 'Date Added'},
                {id: 'TITLE', name: 'Title'},
                {id: 'PRICE', name: 'Price'}
            ];

            SeoModel.applyMetaTags($state.current.name);
            SortFilterFactory.resetFilterObj();

            wishListCtrl.currentState = $state.current.name;
            wishListCtrl.headerAudiobookList = [];

            GA.trackPageView($location.path());

            if (isMobile.iOS()) {
                document.location.href = 'estoriesapp://wishlist';
            }

            const globalFilterObj = SortFilterFactory.filterObj;
            globalFilterObj.sortField = $stateParams.sortField || 'date_added';
            wishListCtrl.sortField = globalFilterObj.sortField != null ? globalFilterObj.sortField.toUpperCase() : null;


            this.refreshHeaderAudiobookList = () => {
                this.headerAudiobookList = this.wishList.map(v => v.audiobook);
            };

            // noinspection JSUnusedGlobalSymbols
            this.shouldShowGridView = () => {
                if ($rootScope.windowWidth <= 768) {
                    return true;
                }
                return !!this.showGridView;
            };

            this.refreshTopBarData = (count) => {
                const tab = {id: 'ACTIVE', name: `Audiobooks`};
                if (count) {
                    tab.name = `${tab.name} (${count})`;
                    this.wishlistTotalCount = count;
                }
                this.tabList = [tab];
            };

            $scope.$on('sortFieldSelected', (e, sortField, index) => {
                this.selectedSortFieldIndex = index;
                wishListCtrl.wishList = null;
                this.gotoPage(1);
            });

            $scope.$on('gridListButtonClicked', (e, showGridView) => {
                this.showGridView = showGridView;
                safeApply($scope);
            });

            wishListCtrl.getWishlistPage = async (pageNumber) => {
                const sortField = this.sortFieldList[this.selectedSortFieldIndex].id;
                const descending = sortField !== "TITLE";
                const itemsPerPage = 40;
                const pagination = PagingModel.preparePagination(pageNumber, itemsPerPage, descending, true, sortField);
                const response = await LibraryModel.getWishList(pagination);
                if (response['responseStatus'] !== 'SUCCESS') {
                    return;
                }
                const totalCount = response.totalCount;
                this.refreshTopBarData(totalCount);
                if (wishListCtrl.wishList && pageNumber > 1) {
                    wishListCtrl.wishList = wishListCtrl.wishList.concat(response.wishList);
                } else {
                    wishListCtrl.wishList = response.wishList;
                }
                wishListCtrl.refreshHeaderAudiobookList();
                this.currentPagination = {pageNumber, itemsPerPage, totalCount};
                $timeout(function () {
                    $rootScope.$broadcast('setTotalCount', response.totalCount);
                    $rootScope.$broadcast('hasMoreBooksToLoad', response.totalCount > wishListCtrl.wishList.length);
                }, 0);

                if (wishListCtrl.wishList.length !== 0) {
                    return;
                }

                wishListCtrl.emptySection = {
                    id: 'EDITORS_PICKS_' + LibraryModel.getSectionItemLocation(),
                    title: 'Editor\'s Picks'
                };
                await wishListCtrl.getSectionItemList(wishListCtrl.emptySection.id, 1, 12, function (response) {
                    wishListCtrl.emptySectionList = response.sectionItemList;
                    safeApply($scope);
                });
            };

            wishListCtrl.getWishlistPage(this.currentPagination.pageNumber).then();

            wishListCtrl.addToWishList = async function (wishListItem) {
                const response = await CatalogModel.addToWishList(wishListItem.audiobook);
                wishListItem.id = response.wishListItemId;
            };

            wishListCtrl.removeFromWishList = async function (wishListItem) {
                await CatalogModel.deleteFromWishList(wishListItem);
                wishListItem.id = null;
            };

            wishListCtrl.getSectionItemList = async function (sectionId, pageNumber, pageSize, callbackFunc) {
                const getSectionItemListObj = {
                    sectionId: sectionId,
                    pagination: PagingModel.preparePagination(pageNumber, pageSize)
                };
                const response = await CatalogModel.getSectionItemList(getSectionItemListObj);
                if (callbackFunc) {
                    callbackFunc(response);
                }
            };

            this.gotoPage = async (pageNumber) => {
                if (parseInt($stateParams.pageNumber) === pageNumber &&
                    parseInt($stateParams.sortField) === this.selectedSortFieldIndex &&
                    (parseInt($stateParams.grid) === 1) === this.showGridView) {
                    this.libraryList = null;
                    await this.getLibraryPage(pageNumber);
                } else {
                    $location.search({
                        'pageNumber': pageNumber,
                        'sortField': this.selectedSortFieldIndex,
                        'grid': this.showGridView ? 1 : 0
                    });
                }
                safeApply($scope);
            };

            $scope.$on('getPage', (event, pageNumber) => {
                this.gotoPage(pageNumber);
            });

            $scope.$on('loadMore', function (event, pageNumber) {
                wishListCtrl.getWishlistPage(pageNumber).then();
            });

            $scope.$on('updateWishlist', function (event, wishlistItemId) {
                wishListCtrl.removeEntryFromWishlist(wishlistItemId);
            });

            this.removeEntryFromWishlist = (wishlistItemId) => {
                const wishList = this.wishList;
                for (let i = 0; i < wishList.length; i++) {
                    if (wishList[i].audiobook.wishListItemId === wishlistItemId) {
                        wishList.splice(i, 1);
                        break;
                    }
                }
                this.refreshHeaderAudiobookList();
                this.refreshTopBarData(this.wishlistTotalCount - 1);
                safeApply($scope);
            };

            $scope.$on("NOTIFICATION_WISHLIST_ITEM_ADDED", function () {
                $state.reload();
            });

            $scope.$on("NOTIFICATION_WISHLIST_ITEM_DELETED", function () {
                $state.reload();
            });

        }]);
